const config = {
  Auth: {
    region: 'eu-north-1',
    userPoolId: process.env.USER_POOL_ID,
    userPoolWebClientId: process.env.USER_POOL_WEB_CLIENT_ID,
    mandatorySignIn: false,
    signUpVerificationMethod: 'link', // 'code' | 'link'
    cookieStorage: {
      domain: process.env.AWS_COOKIE_DOMAIN,
      path: '/',
      expires: 365,
      // OPTIONAL - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
      sameSite: 'strict',
      secure: true, // ignored on localhost
    },
  },
};

export default config;
